import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  errorMessage: {
    color: 'red', fontSize: '12px', paddingTop: '17px',
  },
});
